export const PricingData = [
    {
        id: 1,
        price: '80',
        category: 'basic'
    },
    {
        id: 2,
        price: '100',
        category: 'standart'
    },
    {
        id: 3,
        price: '180',
        category: 'premium'
    },
]